import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { eventsBySectionsQuery } from "../../../../../utils/entitiesFiltersUtils";
import { selectEntitiesByFilters } from "../../../../../store/views/entityView";
import endPointsSections from "../../../../../store/models/endPointsSections";
import CalendarEventsByDate from "./CalendarEventsByDate/CalendarEventsByDate";
import classes from './CalendarWeekEvents.module.css'

export const eventsDisplayPolicyTypes = {
    todayOrNextEvents: "todayOrNextEvents",
}

const CalendarWeekEvents = ({ selectedDate, eventsDisplayPolicy, newStyle }) => {

    const isAuth = useSelector((state) => state.auth.isAuth);
    const { userDetails } = useSelector((state) => state.auth);
    const schoolId = userDetails?.defaultSchool?.id;
    const myEventsQuery = useMemo(() => eventsBySectionsQuery(endPointsSections.calendar, schoolId), [schoolId]);
    const events = useSelector((state) => selectEntitiesByFilters(state, myEventsQuery));
    const generalData = useSelector((state) => state.uiData.general);
    const { texts } = useSelector(state => state.translate);
    const [eventsByDate, setEventsByDate] = useState({})
    const [filterEventsRes, setFilterEventsRes] = useState()
    const [nearestEvent, setNearestEvent] = useState()

    useEffect(() => {
        let eventsObject = {}
        let sortedEvents = [...events].sort((eventA, eventB) => new Date(eventA.date) - new Date(eventB.date))

        sortedEvents.forEach(event => {
            const dateKey = new Date(event.date).toDateString();
            eventsObject[dateKey] = eventsObject[dateKey] || [];
            eventsObject[dateKey].push(event);
        });

        // const nearestEvent = Object.values(eventsObject)
        //     .map(eventsArray => eventsArray.find(event => !event.IsAllDay && new Date(event.date) >= new Date()))
        //     .filter(event => event)[0];
        // setNearestEvent(nearestEvent);

        setEventsByDate(eventsObject)

    }, [events])

    const filterEvents = () => {
        if (eventsDisplayPolicy?.strategy === eventsDisplayPolicyTypes.todayOrNextEvents)
            return getTodayOrNextEvents(eventsByDate, selectedDate, eventsDisplayPolicy.nextEventsCount);
        return getUpcomingEventsFromSelectedDate(eventsByDate, selectedDate, generalData?.filterCalendarEvents);
    }

    useEffect(() => {
        if (generalData)
            setFilterEventsRes(filterEvents())
    }, [generalData, eventsByDate, selectedDate, eventsDisplayPolicy])


    return (
        <div className={classes.CalendarEvents}>

            {!isAuth && !newStyle && <p className={classes.UpcomingEvents}>{texts.allEvents}</p>}

            <div className={classes.Events}>
                {filterEventsRes && Object.keys(filterEventsRes)?.length > 0 ?
                    Object.keys(filterEventsRes)?.map((dateKey, index) =>
                        <CalendarEventsByDate eventIndex={index} key={dateKey} nearestEvent={nearestEvent} events={filterEventsRes[dateKey]} dateKey={dateKey} selectedDate={selectedDate} newStyle={newStyle} />
                    )
                    :
                    <p className={classes.NoUpcomingEvents}>{texts.noUpcomingEvents}</p>
                }

            </div>

        </div >
    )
}

export default CalendarWeekEvents;

const getDayTime = (date) => new Date(date).setHours(0, 0, 0, 0);

const getTodayOrNextEvents = (eventsByDate, selectedDate, nextEventsCount = 3) => {

    const todayKey = new Date(selectedDate).toDateString();
    if (eventsByDate[todayKey]?.length > 0)
        return { [todayKey]: eventsByDate[todayKey] };

    return Object.entries(eventsByDate)
        .flatMap(([dateKey, events]) => events.map(event => ({ dateKey, event })))
        .filter(({ event }) => getDayTime(event.date) > getDayTime(selectedDate))
        .slice(0, nextEventsCount)
        .reduce((resultObject, { dateKey, event }) => {
            resultObject[dateKey] = resultObject[dateKey] || [];
            resultObject[dateKey].push(event);
            return resultObject;
        }, {});
}

const getUpcomingEventsFromSelectedDate = (eventsByDate, selectedDate, eventsCount) => {
    const entries = Object.entries(eventsByDate)
        .filter(([event]) => getDayTime(event) >= getDayTime(selectedDate))
        .slice(0, eventsCount);
    const resultObject = {};
    for (let [key, value] of entries) {
        resultObject[key] = value;
    }
    return resultObject
}